module.exports = __webpack_public_path__ + "assets/img/4p.4122b8f2.png";